module.exports = __webpack_public_path__ + "img/icon-delete.dd90039f.svg";